import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminGroupsRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/groups',
  validateSearch: z.object({
    page: zodPage,
    query: z.string().optional(),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() => import('pages/admin/Groups/AdminGroupsPage/AdminGroupsPage').then((d) => d.Route));
